var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6366 12.0693C10.2757 12.0693 9.96276 11.92 9.31299 11.5021L0.914609 6.03937C0.50554 5.77076 0.000128844 6.15868 0.000128844 6.72589V16.2185C0.000128844 17.5617 0.890459 18.6364 1.94928 18.6364H19.3236C20.4064 18.6364 21.2727 17.5319 21.2727 16.2185V6.75574C21.2727 6.15877 20.7673 5.8004 20.3582 6.06922L11.9599 11.5021C11.3101 11.8902 10.9972 12.0693 10.6363 12.0693M19.9491 0.636406H1.94915C0.866309 0.636406 0 1.74084 0 3.05428C0 3.35287 0.120355 3.6215 0.336889 3.7408L10.3476 10.2781C10.5401 10.3975 10.7566 10.3975 10.9251 10.2781L20.9358 3.7408C21.1524 3.5915 21.2727 3.35267 21.2727 3.05428V2.27821C21.2725 1.38263 20.6709 0.636353 19.949 0.636353",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7cf2d4d60de19ad797deef515a5c87b3.svg";
export { ForwardRef as ReactComponent };